<template>
  <b-modal
    :visible="shown"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hide="handleClose"
    hide-footer
    title="Details">
    <record
      v-if="record"
      :record="record"
      :file-type="fileType" />
  </b-modal>
</template>

<script>
  import Record from './Record';

  export default {
		name: 'RecordModal',
    components: {Record},
    props: {
			shown: Boolean,
      fileType: {
        type: String,
        required: true
      },
      record: {
        type: Object,
        required: true
      }
    },
    methods: {
			handleClose() {
				this.$emit('close');
      }
    }
	};
</script>

<style scoped>

</style>
